var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('cmsDetailContentCompoenent',{attrs:{"lang":_vm.lang,"PageData":_vm.pageData,"general":"general"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }